import React, { useEffect, useRef, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useLocation } from "react-router-dom";
import { faBars, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import Breadcrumb from '../Breadcrumb/Breadcrumb'
import HeaderFeaturedNav from './HeaderFeaturedNav'
import LoginRegistrationNav from './LoginRegistrationNav'
import HeaderNotificationNav from './HeaderNotificationNav'
import HeaderProfileNav from './HeaderProfileNav'
import HeaderMembership from './HeaderMembership'
import { Button, Container, Badge, Form, Modal, Row, Col, ListGroup, InputGroup, FormControl, Dropdown, Spinner } from 'react-bootstrap'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../../../services/AuthService.js";
import progressDots from './/./../../../assets/img/progress_dots_cropped.gif'
import newTOTLogo from './/./../../../assets/brand/UpdatedLogo.png'

//import { ReactComponent as Logo } from './/./../../../assets/brand/coreui.svg';

export default function Header(props) {
    //properties
    const { getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation();
    const isAdminDashboard = location.pathname.toLowerCase().includes("admindashboard");

    const { setAccountProfile, toggleSidebar, toggleSidebarMd, setIsShowSidebarMd, accountProfile, currentAccount, baseUrl, logoutRedirectUrl, isShowSidebar, isShowSidebarMd } = props
    const { isAuthenticated } = useAuth0();

    const [primaryCompanies, setPrimaryCompanies] = useState([]);
    const [selectedAccountId, setSelectedAccountId] = useState(null);
    const [dataStatus, setDataStatus] = useState('ready');

    const [showAttention, setShowAttention] = useState(true);
    const attentionTimerRef = useRef(null);
    const pillRef = useRef(null);
    const [pillWidth, setPillWidth] = useState(null);

    useEffect(() => {
        if (!pillRef.current) return;
        const observer = new ResizeObserver(entries => {
            setPillWidth(entries[0]?.contentRect.width ?? pillRef.current?.offsetWidth ?? null);
        });
        observer.observe(pillRef.current);
        setPillWidth(pillRef.current.offsetWidth);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!isShowSidebar) {
            if (attentionTimerRef.current) clearTimeout(attentionTimerRef.current);
            setShowAttention(true);
            attentionTimerRef.current = setTimeout(() => setShowAttention(false), 30000);
        }
        return () => { if (attentionTimerRef.current) clearTimeout(attentionTimerRef.current); };
    }, [isShowSidebar]);

    useEffect(() => {
        if (!isShowSidebarMd) {
            if (attentionTimerRef.current) clearTimeout(attentionTimerRef.current);
            setShowAttention(true);
            attentionTimerRef.current = setTimeout(() => setShowAttention(false), 30000);
        }
        return () => { if (attentionTimerRef.current) clearTimeout(attentionTimerRef.current); };
    }, [isShowSidebarMd]);

    //Search form
    const [companySearchModalShow, setCompanySearchModalShow] = useState(false);
    //const handleOpenSearchModal = () => setCompanySearchModalShow(true);
    //const handleCloseSearchModal = () => setCompanySearchModalShow(false);

    const imgStyle = {
        position: 'relative',
        height: '30px',
        width: '100px',
        left: '10px',
        top: '0',
        right: '0',
        bottom: '0',
        color: 'transparent',
        border: 'none',
        display: dataStatus != 'ready' ? 'block' : 'none'
    };

    const imgStyleLogo = {
        position: 'relative',
        height: '30px',
        width: '30px',
        left: '0',
        top: '0',
        right: '0',
        bottom: '0',
        marginRight: '10px',
        color: 'transparent',
        border: '1px solid black',
        borderRadius: '15%'
    };

    //populate primary companies
    //const populatePrimaryCompanies = async () => {
    //    //console.log('Populating Primary Companies...');

    //    setDataStatus('loading');

    //    //get primary companies for dropdown
    //    await getPrimaryCompanies()
    //        .then(response => {
    //            if (response.success) {
    //                setPrimaryCompanies(response.data);
    //                setSelectedAccountId(accountProfile.accountId);
    //            }
    //        })
    //        .catch(ex => {
    //            const blah = 1;
    //            //setPageStatus('error');
    //            //setPageErrors(ex.message);
    //        })
    //        .finally(response => {
    //            setDataStatus('ready');
    //        })
    //};

    //get primary companies
    const getPrimaryCompanies = async () => {
        console.log('Getting Primary Companies...');

        const apiUrl = 'accounts/primarycompanies';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = response.ok ? await response.json() : [];
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    //handle company change
    const handleCompanyChange = async (event) => {
        const fieldName = event.target.name;
        const value = event.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + value);

        setSelectedAccountId(value);
        setDataStatus('loading');

        setCompanySearchModalShow(false);

        //get primary companies for dropdown
        await getAccountSwitch(value)
            .then(response => {
                if (response.success) {
                    localStorage.removeItem('dataFileState');

                    //refresh site at home page with new token
                    let alink = document.createElement('a');
                    alink.href = window.location.origin;
                    alink.click();
                } else {
                    setPrimaryCompanies([]);
                }
            })
            .catch(ex => {
                //setPageStatus('error');
                //setPageErrors(ex.message);
            })
            .finally(response => {
                setDataStatus('ready');
            })
    };

    //get account switch
    const getAccountSwitch = async (accountId) => {
        //console.log('Switching Account...');

        const apiUrl = 'accounts/accountswitch/' + accountId;
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = response.ok ? await response.json() : [];
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    /*Primary company search form*/
    //function CompanySearchModal({ show, handleClose, companies }) {
    //    const [searchTerm, setSearchTerm] = useState('');
    //    const criteriaLabels = {
    //        A: 'Admin',
    //        B: 'Test Account',
    //        C: 'Owner',
    //        D: 'Operator'
    //    }
    //    const [checkedCriteria, setCheckedCriteria] = useState({
    //        A: true,    //Show Admin
    //        B: true,    //Show Test Account
    //        C: true,    //Show Owner
    //        D: true,    //Show Operator
    //    });

    //    const handleCheckboxChange = (e) => {
    //        const { name, checked } = e.target;
    //        setCheckedCriteria((prev) => ({
    //            ...prev,
    //            [name]: checked,
    //        }));
    //    };

    //    const handleSearchChange = (e) => {
    //        setSearchTerm(e.target.value);
    //    }

    //    const matchesCheckedCriteria = (company) => {
    //        if (checkedCriteria.A && company.companyTypeId === 0) {
    //            return true;
    //        }
    //        if (!checkedCriteria.B && company.isTestAccount) {
    //            return false;
    //        }
    //        if (!checkedCriteria.A && checkedCriteria && company.companyTypeId === 0) {
    //            return false;
    //        }
    //        if ((checkedCriteria.A && company.companyTypeId === 0) || (checkedCriteria.B && company.isTestAccount) ||
    //            (checkedCriteria.C && company.companyTypeId === 4) || (checkedCriteria.D && company.companyTypeId === 1)) {
    //            return true;
    //        }
    //    }

    //    //filter the list as you type
    //    const filteredCompanies = companies.filter((company) => {
    //        if (
    //            searchTerm &&
    //            !company.companyName.toLowerCase().startsWith(searchTerm.toLowerCase())
    //        ) {
    //            return false;
    //        }
    //        if (matchesCheckedCriteria(company)) {
    //            return true;
    //        }
    //        return false;
    //    });

    //    return (
    //        <Modal show={show} onHide={handleClose} centered >
    //            <Modal.Header closeButton>
    //                <Modal.Title id="contained-modal-title-vcenter">
    //                    <h4>Search Companies</h4>
    //                </Modal.Title>
    //            </Modal.Header>

    //            <Modal.Body>
    //                <InputGroup className="mb-3">
    //                    <FormControl
    //                        placeholder="Search by name..."
    //                        value={searchTerm}
    //                        onChange={handleSearchChange}
    //                    />
    //                </InputGroup>

    //                <Form>
    //                    <Row>
    //                        {Object.keys(checkedCriteria).map((key) => (
    //                            <Col xs={6} key={key}>
    //                                <Form.Check
    //                                    type="checkbox"
    //                                    label={criteriaLabels[key]}
    //                                    name={key}
    //                                    checked={checkedCriteria[key]}
    //                                    onChange={handleCheckboxChange}
    //                                    className="mb-2"
    //                                />
    //                            </Col>
    //                        ))}
    //                    </Row>
    //                </Form>

    //                <ListGroup className="mt-3" style={{ maxHeight: '400px', minHeight: '400px', overflowY: 'auto' }}>
    //                    {filteredCompanies.length > 0 ? (
    //                        filteredCompanies.map((company, i) => (
    //                            <ListGroup.Item
    //                                key={company.accountId}
    //                                action
    //                                value={selectedAccountId}
    //                                onClick={handleCompanyChange}
    //                            >
    //                                <option key={i} value={company.accountId}>{(company.companyName)}</option>
    //                            </ListGroup.Item>
    //                        ))
    //                    ) : (
    //                        <ListGroup.Item>No matching companies.</ListGroup.Item>
    //                    )}
    //                </ListGroup>
    //            </Modal.Body>


    //            <Modal.Footer>
    //                <Button variant="seconday" onClick={handleClose}>
    //                    Close
    //                </Button>
    //            </Modal.Footer>
    //        </Modal>
    //    );
    //}


    return (
        <header className={`header sticky-top mb-4 p-2 ${baseUrl.includes("totdata-api.azurewebsites") || baseUrl.includes("localhostblah") ? 'border-bottom' : ''}`} style={{ borderBottom: (baseUrl.includes("local") ? 'solid 2px lightblue' : baseUrl.includes("dev") ? 'solid 2px green' : baseUrl.includes("qa") ? 'solid 2px orange' : baseUrl.includes("demo") ? 'solid 2px blue' : baseUrl.includes("stage") ? 'solid 2px red' : 'none') }}>
            <style>{`
                @keyframes hamPulse {
                    0%   { filter: drop-shadow(0 0 0px rgba(200,181,104,0)); }
                    50%  { filter: drop-shadow(0 0 7px rgba(200,181,104,0.90)); }
                    100% { filter: drop-shadow(0 0 0px rgba(200,181,104,0)); }
                }
                .ham-attention {
                    animation: hamPulse 1.4s ease-in-out infinite;
                }
                .ham-btn {
                    transition: color 0.2s ease, opacity 0.2s ease !important;
                }
                @media (prefers-reduced-motion: reduce) {
                    .ham-attention { animation: none; }
                }
            `}</style>
            <Container fluid className="header-navbar d-flex align-items-center" >
                <Button
                    variant="link"
                    className={`ham-btn header-toggler d-md-none px-md-0 me-md-3 rounded-0 shadow-none${!isShowSidebar && showAttention ? ' ham-attention' : ''}`}
                    type="button"
                    style={{ color: '#C8B568', marginLeft: '-8px' }}
                    onClick={toggleSidebar}
                >
                    <FontAwesomeIcon icon={isShowSidebar ? faAngleLeft : faBars} />
                </Button>

                <Button
                    variant="link"
                    className={`ham-btn header-toggler d-none d-md-flex px-md-0 rounded-0 shadow-none${!isShowSidebarMd && showAttention ? ' ham-attention' : ''}`}
                    type="button"
                    onClick={toggleSidebarMd}
                    style={{ color: '#C8B568', fontSize: '18px', marginLeft: '-8px' }}
                >
                    <FontAwesomeIcon icon={isShowSidebarMd ? faAngleLeft : faBars} />
                </Button>

                {/*{(() => {*/}
                {/*    if (baseUrl.includes("totdata-api.")) {*/}
                {/*        return <img*/}
                {/*            object-fit="fill"*/}
                {/*            src={newTOTLogo}*/}
                {/*            alt="totdata.com"*/}
                {/*            style={imgStyleLogo}*/}
                {/*        />*/}
                {/*    }*/}
                {/*})()}*/}

                {/*<div className="header-nav d-none d-md-flex">*/}
                {/*    <Breadcrumb />*/}
                {/*</div>*/}

                <div className="header-nav" style={{ marginTop: '0px', marginLeft: '30px', flex: '1 1 0', minWidth: 0 }} >
                    {(() => {
                        if (isAuthenticated) {
                            return <HeaderMembership accountProfile={accountProfile} currentAccount={currentAccount} baseUrl={baseUrl} />
                        }
                        else {
                            return ''
                        }
                    })()}
                </div>

                <div className="ms-auto d-flex align-items-center" style={{ gap: '8px', minWidth: 0 }}>
                    {baseUrl && !baseUrl.includes("totdata-api.azurewebsites") && (
                        <Badge bg={baseUrl.includes("local") ? 'info' : baseUrl.includes("dev") ? 'success' : baseUrl.includes("qa") ? 'warning' : baseUrl.includes("demo") ? 'primary' : baseUrl.includes("stage") ? 'danger' : 'secondary'} style={{ fontSize: '0.8rem', padding: '6px 14px', flexShrink: 0 }}>
                            {baseUrl.includes("local") ? 'Local Dev' : baseUrl.includes("dev") ? 'Development' : baseUrl.includes("qa") ? 'QA' : baseUrl.includes("demo") ? 'Demo' : baseUrl.includes("stage") ? 'Stage' : ''}
                        </Badge>
                    )}
                    {isAuthenticated && (
                        <div ref={pillRef} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '6px 8px 6px 12px', flexShrink: 0, boxShadow: '0 2px 8px rgba(0,0,0,.10)' }}>
                            <div style={{ overflow: 'hidden', minWidth: 0 }}>
                                {accountProfile.hasImpersonate ? (
                                    <>
                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#1f2937', fontSize: '0.82rem', fontWeight: '600' }}>
                                            {((accountProfile.firstName ?? '') == '' || (accountProfile.lastName ?? '') == '') ? accountProfile.email : accountProfile.firstName + ' ' + accountProfile.lastName}
                                        </div>
                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#6e5f20', fontSize: '0.78rem', fontWeight: '700' }}>
                                            {accountProfile.accountName.toUpperCase()}
                                        </div>
                                        <img object-fit="fill" src={progressDots} alt="user@email.com" style={imgStyle} />
                                    </>
                                ) : (
                                    <>
                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#1f2937', fontSize: '0.82rem', fontWeight: '600' }}>
                                            {((accountProfile.firstName ?? '') == '' || (accountProfile.lastName ?? '') == '') ? accountProfile.email : accountProfile.firstName + ' ' + accountProfile.lastName}
                                        </div>
                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#6e5f20', fontSize: '0.78rem', fontWeight: '700' }}>
                                            {accountProfile.accountName.toUpperCase()}
                                        </div>
                                    </>
                                )}
                            </div>
                            <HeaderProfileNav setAccountProfile={setAccountProfile} toggleSidebarMd={toggleSidebarMd} setIsShowSidebarMd={setIsShowSidebarMd} accountProfile={accountProfile} logoutRedirectUrl={logoutRedirectUrl} pillWidth={pillWidth} pillRef={pillRef} />
                        </div>
                    )}
                </div>
            </Container>

            {/*Primary company search form*/}
            {/*{dataStatus === 'ready' && (*/}
            {/*    <CompanySearchModal*/}
            {/*        show={companySearchModalShow}*/}
            {/*        handleClose={handleCloseSearchModal}*/}
            {/*        companies={primaryCompanies}*/}
            {/*    />*/}
            {/*)}*/}
        </header>
    )
}
